<div>
  <div mat-card-title>Ongoing Orders</div>
  <div class="mt-2 p-1">
    <nz-table #nzTable [nzData]="ongoingOrders" nzTableLayout="fixed" nzBordered nzShowPagination="false" nzShowSizeChanger
      nzOuterBordered>
      <thead>
        <tr>
          <th class="text-center">Order Status</th>
          <th class="text-center">Count</th>
        </tr>
      </thead>
      <tbody>
        @for (data of nzTable.data; track data) {
          <tr>
            <td>{{orderStatus[data.orderingStatus]}}</td>
            <td class="text-center">{{data.count}}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</div>
